import React from "react";
import { Link } from "react-router-dom";
import { colors } from "../auth/authStyles";

const SHOP_PHONE = "(647) 608-2860";
const SHOP_PHONE_HREF = "tel:+16476082860";

const BallIcon = () => (
  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke={colors.black} strokeWidth="1.5" />
    <circle cx="12.6" cy="7.4" r="1.2" fill={colors.black} />
    <circle cx="16.2" cy="9" r="1.2" fill={colors.black} />
    <circle cx="12.4" cy="12" r="1.55" fill={colors.black} />
    <path
      d="M5.7 13.6a6.6 6.6 0 0 0 3 4"
      stroke={colors.teal}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const pillStyle = {
  display: "inline-flex",
  alignItems: "center",
  height: "48px",
  padding: "0 1.6rem",
  borderRadius: "999px",
  fontSize: "0.95rem",
  fontWeight: 600,
  textDecoration: "none",
};

// Orders are entered by the shop, so until a customer's first pickup this tab
// only has the empty state.
const OrdersTab = () => (
  <section className="account-section">
    <div className="account-section-head">
      <h2 className="account-section-title">Order history</h2>
      <p style={{ color: colors.muted, fontSize: "0.95rem", margin: 0 }}>
        Questions about an order? Call{" "}
        <a href={SHOP_PHONE_HREF} style={{ color: "inherit" }}>
          {SHOP_PHONE}
        </a>
      </p>
    </div>

    <div
      style={{
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "4.5rem 1.5rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "1.75rem",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "88px",
          height: "88px",
          borderRadius: "999px",
          backgroundColor: colors.page,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <BallIcon />
      </div>
      <div>
        <h3
          style={{
            fontSize: "1.75rem",
            fontWeight: 900,
            letterSpacing: "-0.02em",
            margin: 0,
          }}
        >
          No orders yet.
        </h3>
        <p
          style={{
            color: colors.muted,
            fontSize: "1rem",
            lineHeight: 1.5,
            maxWidth: "440px",
            margin: "0.6rem auto 0",
          }}
        >
          When you pick up a ball, shoes or a service from 900, it'll show up
          here with your receipt.
        </p>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "0.75rem" }}>
        <Link
          to="/balls"
          style={{ ...pillStyle, backgroundColor: colors.black, color: "white" }}
        >
          Browse balls
        </Link>
        <Link
          to="/service"
          style={{
            ...pillStyle,
            border: `1px solid ${colors.border}`,
            color: colors.black,
          }}
        >
          See our services
        </Link>
      </div>
    </div>
  </section>
);

export default OrdersTab;
